// @flow
import ko from 'knockout';
import $ from 'jquery';


function replace (
	string: string,
	pattern: string | RegExp = /\s/g,
	replacement: Function | string = ''): string {
	const value = ko.unwrap(string) || '';
	return value.replace(pattern, replacement);
}

function getParams (valueAccessor) {
	const params = ko.unwrap(valueAccessor());

	return params ? {
		value: params.value || '',
		pattern: params.pattern || undefined,
		replacement: params.replacement || undefined,
	} : { value: '', pattern: undefined, replacement: undefined };
}

function bindingReplace (element, valueAccessor) {
	const { value, pattern, replacement } = getParams(valueAccessor);
	const $element = $(element);

	if (ko.isObservable(value)) {

		value(replace(value(), pattern, replacement));

		$element.change(() => value(replace(value(), pattern, replacement)));

	} else {
		const html = $element.html();
		$element.html(replace(html, pattern, replacement));

		if (!html) {
			const val = $element.val();
			$element.val(replace(val, pattern, replacement));
			$element.change(() => $element.val(replace($element.val(), pattern, replacement)));
		}
	}
}

/**
 *  Заменяет pattern на replacement в html и val или из значния в Observable<string>
 *
 *  Параметры value pattern replacement не обязательны
 *
 *  Полный пример replace:{value: Observable, pattern: 'что меняем', replacement:'на что меням' }
 *
 *  Примеры в коде:
 *  <span data-bind="text: 'any text with spaces', replace"></span>
 *  <span data-bind="text: SeriesDocumentVehicle, replace"></span>
 *  <input class="form-control" type="text"
 *         data-bind="value: SeriesDocumentVehicle,
 *                    replace:{value: SeriesDocumentVehicle}">
 * @type {{init: bindingReplace, update: bindingReplace, after: string[]}}
 */
ko.bindingHandlers.replace = {
	after: ['value', 'text'],
	init: bindingReplace,
	update: bindingReplace,
};
